import { render, staticRenderFns } from "./repairTypeUserList.vue?vue&type=template&id=2f20a9a9&scoped=true"
import script from "./repairTypeUserList.vue?vue&type=script&lang=js"
export * from "./repairTypeUserList.vue?vue&type=script&lang=js"
import style0 from "./repairTypeUserList.vue?vue&type=style&index=0&id=2f20a9a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f20a9a9",
  null
  
)

export default component.exports